import {
  addHtmlElementClass, addHtmlElementEventListener,
  addHtmlRootEventListener,
  getHtmlElement,
  removeHtmlChildren, removeHtmlElementClass,
  renderWebComponent, setHtmlElementClasses, setHtmlElementContent
} from "../../../utils/utils";
import commonStyles from '../../styles/web-components.common.css';
import styles from '../../styles/modal.css'
import { EventBusComponent } from "../EventBusComponent";
import I18n from "i18n-js";

export class ModalComponent extends HTMLElement {

  eventBus = null;
  modal = null;

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
    this.render();
  }

  connectedCallback() {
    const modal = getHtmlElement(this.shadowRoot, 'customModal');
    this.eventBus.subscribe('render-modal', (message) => {
      setTimeout(() => this.setModalContent(message.error, message.body, message.title, message.displayLabelTypes, message.displayServiceTypes, message.errorMessage, message.additionalErrorMessage, message.confirmTxt), 1);
    });

    addHtmlElementEventListener(this.shadowRoot, 'closeButton1', 'click', () => modal.classList.remove("show"));
    addHtmlElementEventListener(this.shadowRoot, 'closeButton2', 'click', () => modal.classList.remove("show"));
    addHtmlRootEventListener(window, 'keydown', (e) => e.key === 'Escape' ? modal.classList.remove("show") : {});

    // window.top.document.addEventListener("click", function(e) {
    //   if (!modal.contains(e.target)) {
    //     modal.classList.remove("show");
    //   }
    // });
  }


  setModalContent(error, body, title, displayLabelTypes, displayServiceTypes, errorMessage, additionalErrorMessage, confirmTxt) {
    if (title || error) {
      removeHtmlElementClass(this.shadowRoot, 'header', 'd-none');
      setHtmlElementContent(this.shadowRoot, 'title', title ? title : I18n.t('js.common.modal.errorTitle'));
    } else {
      setHtmlElementContent(this.shadowRoot, 'title', '');
      addHtmlElementClass(this.shadowRoot, 'header', 'd-none');
    }

    const modalBody = getHtmlElement(this.shadowRoot, 'body');
    removeHtmlChildren(modalBody);

    if (error) {
      removeHtmlElementClass(this.shadowRoot, 'modalContainer', 'modal-lg');
      modalBody.classList.add('d-flex', 'justify-content-center', 'align-items-center', 'mt-4')
      const template = document.createElement('template')
      template.innerHTML = `
        <h4>
          <div class="d-block text-center">
            <div class="d-flex justify-content-center align-items-center">
              <p class="ml-2 text-space">
                ${errorMessage ? errorMessage : I18n.t('js.common.modal.generalError')}
              </p>
            </div>
            ${
              additionalErrorMessage ?
                `<div class="d-flex justify-content-center align-items-center mt-4">
                  <p class="ml-2 text-space">
                    ${ additionalErrorMessage }
                  </p>
                </div>`
              :
                `<span></span>`
            }
          </div>
        </h4>
      `
      modalBody.appendChild(template.content.cloneNode(true));
      setHtmlElementClasses(this.shadowRoot, 'closeButton2', 'btn-standard-outline br-20px pr-2 pl-2 min-w-120px btn-standard-outline-resized h-40px-imp')
    } else {
      addHtmlElementClass(this.shadowRoot, 'modalContainer', 'modal-lg');
      modalBody.classList.remove('d-flex', 'justify-content-center', 'align-items-center', 'mt-4');
      if (body?.length > 0) {
        for (const content of body) {
          const template = document.createElement("template");
          template.innerHTML = `<p>${content}</p>`;
          modalBody.appendChild(template.content.cloneNode(true));
        }

        if (displayLabelTypes) {
          const template = document.createElement("template");
          template.innerHTML = `
            <div class="row mb-2 mt-3">
              <div class="col-12 col-md-6 d-block justify-content-center align-items-center text-center px-2 py-3">
                <img src="/images/radiant-label-img.svg" alt="" class="w-100 mb-3" />
                <p><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.labelTypeOption.radiant')}</b></p>
              </div>
              
              <div class="col-12 col-md-6 d-block justify-content-center align-items-center text-center px-2 py-3">
                <img src="/images/radiant-label-pristine-img.svg" alt="" class="w-100 mb-3" />
                <p><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.labelTypeOption.radiantPristine')}</b></p>
              </div>
            </div>
            <p>${I18n.t("js.editSubmissionListPage.webComponent.questiontip.label_type_p5")}</p>
          `;
          modalBody.appendChild(template.content.cloneNode(true));
        }

        if (displayServiceTypes) {
          const template = document.createElement("template");
          template.innerHTML = `
            <div class="row mb-2 mt-3">
              <div class="col-12 col-md-6 mb-3">
                <h6 class="text-center mb-2"><b>Grading</b></h6>
                <div class="row">
                  <div class="col-6 text-center">
                    <img src="/images/radiant-label-img.svg" alt="Grading Front" class="w-100 mb-2" style="max-height: 120px; object-fit: contain;" />
                    <small>Front</small>
                  </div>
                  <div class="col-6 text-center">
                    <img src="/images/service-back-empty.svg" alt="Grading Back" class="w-100 mb-2" style="max-height: 120px; object-fit: contain;" />
                    <small>Back</small>
                  </div>
                </div>
              </div>
              
              <div class="col-12 col-md-6 mb-3">
                <h6 class="text-center mb-2"><b>Grading with Subgrades</b></h6>
                <div class="row">
                  <div class="col-6 text-center">
                    <img src="/images/radiant-label-img.svg" alt="Grading Subgrades Front" class="w-100 mb-2" style="max-height: 120px; object-fit: contain;" />
                    <small>Front</small>
                  </div>
                  <div class="col-6 text-center">
                    <img src="/images/service-back-subgrades.svg" alt="Grading Subgrades Back" class="w-100 mb-2" style="max-height: 120px; object-fit: contain;" />
                    <small>Back</small>
                  </div>
                </div>
              </div>
              
              <div class="col-12 col-md-6 mb-3">
                <h6 class="text-center mb-2"><b>Authentication</b></h6>
                <div class="row">
                  <div class="col-6 text-center">
                    <img src="/images/service-authentication-front.svg" alt="Authentication Front" class="w-100 mb-2" style="max-height: 120px; object-fit: contain;" />
                    <small>Front</small>
                  </div>
                  <div class="col-6 text-center">
                    <img src="/images/service-back-empty.svg" alt="Authentication Back" class="w-100 mb-2" style="max-height: 120px; object-fit: contain;" />
                    <small>Back</small>
                  </div>
                </div>
              </div>
              
              <div class="col-12 col-md-6 mb-3">
                <h6 class="text-center mb-2"><b>Authentication with Subgrades</b></h6>
                <div class="row">
                  <div class="col-6 text-center">
                    <img src="/images/service-authentication-front.svg" alt="Authentication Subgrades Front" class="w-100 mb-2" style="max-height: 120px; object-fit: contain;" />
                    <small>Front</small>
                  </div>
                  <div class="col-6 text-center">
                    <img src="/images/service-back-subgrades.svg" alt="Authentication Subgrades Back" class="w-100 mb-2" style="max-height: 120px; object-fit: contain;" />
                    <small>Back</small>
                  </div>
                </div>
              </div>
            </div>
          `;
          modalBody.appendChild(template.content.cloneNode(true));
        }
      }
      setHtmlElementClasses(this.shadowRoot, 'closeButton2', 'btn-standard bg-aig-gradient color-white br-20px pr-2 pl-2 min-w-120px btn-standard-resized pt-4px-imp h-35px')
    }

    setHtmlElementContent(this.shadowRoot, 'closeButton2', confirmTxt ? confirmTxt : I18n.t('js.common.ok').toUpperCase())

    addHtmlElementClass(this.shadowRoot, 'customModal', 'show');
  }


  render() {
    const html = `      
      <div class="modal fade" id="customModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document" id="modalContainer">
          <div class="modal-content">
            <div class="modal-header" id="header">
              <h5 class="modal-title" id="title"></h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeButton1">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" id="body"></div>
            <div class="modal-footer">
              <button type="button" 
                class="btn-standard bg-aig-gradient color-white br-20px pr-2 pl-2 min-w-120px btn-standard-resized pt-4px-imp h-35px"
                data-dismiss="modal" id="closeButton2"
              >
                ${I18n.t('js.common.ok').toUpperCase()}
              </button>
            </div>
          </div>
        </div>
      </div>
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles, styles]);
  }
}

window.customElements.define("modal-component", ModalComponent);